/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Modal, Form, Select } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
	RESIDENTIAL_TYPE, FLOORS_NUMBER, ROOF_MATERIALS, OUTERWALLS_MATERIALS,
	FLOOR_FINISHING_MATERIALS, FLOOR_CONSTRUCTION_MATERIALS, REPAIR_STATE,
	BUILT_YEAR, FLOOR_AREA, TENURE_STATUS, HOUSE_ACQUISITION, MONTHLY_RENTAL,
	GARBAGE_DISPOSAL, TOILET_FACILITY, LIGHTING_FUEL, COOKING_FUEL, WATER_SUPPLY_DRINKING,
	WATER_SUPPLY_COOKING, LAND_LOCATION, LAND_OWNERSHIP, PRESENCE_OPERATOR
} from '../../../constants/householdlookup'

import PurokSelect from '../../../components/Custom/PurokSelect'
import Checkbox from '../../../components/Custom/CustomCheckbox'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedPurok: null
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedHousehold, form } = this.props
		const { setFieldsValue } = form
		if (!selectedHousehold) {
			setFieldsValue({
				is_system_generated_hhn: true
			})
		}
		if (selectedHousehold) {
			this.setState({ selectedPurok: { uid: selectedHousehold.purok_uid } })
			setFieldsValue({
				purok_uid: selectedHousehold.purok_name,
				is_system_generated_hhn: _.isEqual(selectedHousehold.is_system_generated, 1) ? true : false,
				house_no: selectedHousehold.house_no,
				block: selectedHousehold.block,
				lot: selectedHousehold.lot,
				street: selectedHousehold.street,
				address: selectedHousehold.address,
				living_in_makeshift_housing: selectedHousehold.living_in_makeshift_housing,
				withou_access_to_safe_water: selectedHousehold.withou_access_to_safe_water,
				without_access_to_sanitary_toilet: selectedHousehold.without_access_to_sanitary_toilet,
				income_below_poverty: selectedHousehold.income_below_poverty,
				income_below_food: selectedHousehold.income_below_food,
				experienced_food_shortage: selectedHousehold.experienced_food_shortage,
				residential_type: selectedHousehold.residential_type,
				floor_numbers: selectedHousehold.floor_numbers,
				roof_materials: selectedHousehold.roof_materials,
				outerwall_materials: selectedHousehold.outerwall_materials,
				floor_finishing_materials: selectedHousehold.floor_finishing_materials,
				floor_construction_materials: selectedHousehold.floor_construction_materials,
				repair_state: selectedHousehold.repair_state,
				built_year: selectedHousehold.built_year,
				floor_area: selectedHousehold.floor_area,
				tenure_status: selectedHousehold.tenure_status,
				house_acquisition: selectedHousehold.house_acquisition,
				monthly_rental: selectedHousehold.monthly_rental,
				garbage_disposal: selectedHousehold.garbage_disposal,
				toilet_facility: selectedHousehold.toilet_facility,
				lighting_fuel: selectedHousehold.lighting_fuel,
				cooking_fuel: selectedHousehold.cooking_fuel,
				water_supply_drinking: selectedHousehold.water_supply_drinking,
				water_supply_cooking: selectedHousehold.water_supply_cooking,
				land_location: selectedHousehold.land_location,
				land_ownership: selectedHousehold.land_ownership,
				presence_operator: selectedHousehold.presence_operator,
				
			})
			setTimeout(() => {
				setFieldsValue({
					roof_materials_others: selectedHousehold.roof_materials_others,
					outerwall_materials_others: selectedHousehold.outerwall_materials_others,
					floor_finishing_materials_others: selectedHousehold.floor_finishing_materials_others,
					floor_construction_materials_others: selectedHousehold.floor_construction_materials_others,
					house_acquisition_others: selectedHousehold.house_acquisition_others,
					garbage_disposal_others: selectedHousehold.garbage_disposal_others,
					toilet_facility_others: selectedHousehold.toilet_facility_others,
					lighting_fuel_others: selectedHousehold.lighting_fuel_others,
					cooking_fuel_others: selectedHousehold.cooking_fuel_others,
					water_supply_drinking_others: selectedHousehold.water_supply_drinking_others,
					water_supply_cooking_others: selectedHousehold.water_supply_cooking_others,
					land_ownership_others: selectedHousehold.land_ownership_others,
					presence_operator_others: selectedHousehold.presence_operator_others,
				})
			}, 500)
			if (_.isEqual(selectedHousehold.is_system_generated, 0)) {
				setTimeout(() => {
					setFieldsValue({
						custom_household_no: selectedHousehold.household_no
					})
				}, 500)
			}
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { 
			form, onClose, saveHousehold, AuthStore, selectedHousehold
		} = this.props
		const { selectedPurok } = this.state
		const { resetFields } = form
		const { barangay_uid } = AuthStore
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			values = Object.assign({}, values, { 
				barangay_uid,
				is_system_generated_hhn: _.isEqual(values.is_system_generated_hhn, true) ? 1 : 0
			})
			if (selectedHousehold) {
				values = Object.assign({}, values, { household_uid: selectedHousehold.uid })
			}
			if (selectedPurok) {
				values = Object.assign({}, values, { purok_uid: selectedPurok.uid })
			} else {
				values = Object.assign({}, values, { purok_uid: null })
			}
			// console.log('values', values)

			message.loading({ key: 'set_household', content: 'Saving household, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveHousehold(values).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_household', content: 'Household successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'Household',
						action: selectedHousehold ? 'Update' : 'Create',
						message: `${selectedHousehold ? 
							'Update' : 'Created new'} household data of ${values.house_no} ${values.street} ${values.address} `
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay household')
					message.error({ key: 'set_household', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { isSaving } = this.state
		const { visible, onClose, form, AuthStore, selectedHousehold } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid } = AuthStore
		
		return (
			<Modal
				title='Add New Household'
				// placement="right"
				// closable={!isSaving}
				// onClose={onClose}
				visible={visible}
				width={'80%'}
				// bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
				okText='Save'
				maskClosable={!isSaving}
				onCancel={onClose}
				onOk={this.handleSubmit}
				confirmLoading={isSaving}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Col md={6} sm={24}>
							{
								!getFieldValue('is_system_generated_hhn') &&
								<Form.Item label='Household Number'>
									{ getFieldDecorator('custom_household_no', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}]
									})
									(
										<Input type='number' min='0' placeholder='Enter household number'/>
									)}
								</Form.Item>
							}
							{
								(getFieldValue('is_system_generated_hhn') && selectedHousehold) &&
								<div>
									<span>Household Number: </span>
									<span style={{ fontWeight: 'bold', fontSize: 18 }}>&nbsp; &nbsp;{selectedHousehold.household_no}</span>
								</div>
							}
							<Form.Item label=''>
								{ getFieldDecorator('is_system_generated_hhn', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>household number is auto-generated?</Checkbox>
								)}
							</Form.Item>
						</Col>
					</Row>
					<legend>Address</legend>
					<Row gutter={16}>
						<Col md={6} sm={24}>
							<Form.Item label='Purok'>
								{ getFieldDecorator('purok_uid', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<PurokSelect 
										barangay_uid={barangay_uid}
										onSelectedItem={(item) => this.setState({ selectedPurok: item }) }
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='House/Unit No.'>
								{ getFieldDecorator('house_no', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter House/Unit number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Block No.'>
								{ getFieldDecorator('block', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Block number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Lot'>
								{ getFieldDecorator('lot', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Lot number'/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Street'>
								{ getFieldDecorator('street', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Street'/>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Sitio/Subdivision'>
								{ getFieldDecorator('address', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Sitio/Subdivision'/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<legend>Status</legend>
					<Row gutter={16}>
						<Col md={6} sm={24}>
							<Form.Item label='Living in makeshift housing?'>
								{ getFieldDecorator('living_in_makeshift_housing', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Status' allowClear>
										<Select.Option value={1}>Yes</Select.Option>
										<Select.Option value={0}>No</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Income below poverty threshold?'>
								{ getFieldDecorator('income_below_poverty', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Status' allowClear>
										<Select.Option value={1}>Yes</Select.Option>
										<Select.Option value={0}>No</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Income below food threshold?'>
								{ getFieldDecorator('income_below_food', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Status' allowClear>
										<Select.Option value={1}>Yes</Select.Option>
										<Select.Option value={0}>No</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={6} sm={24}>
							<Form.Item label='Experienced food shortage?'>
								{ getFieldDecorator('experienced_food_shortage', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Status' allowClear>
										<Select.Option value={1}>Yes</Select.Option>
										<Select.Option value={0}>No</Select.Option>
									</Select>
								)}
							</Form.Item>
						</Col>
					</Row>
					<legend>Housing Census</legend>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Type of residential housing / building'>
								{ getFieldDecorator('residential_type', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											RESIDENTIAL_TYPE.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Number of floors of the building / housing unit'>
								{ getFieldDecorator('floor_numbers', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											FLOORS_NUMBER.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Construction materials of the roof'>
								{ getFieldDecorator('roof_materials', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											ROOF_MATERIALS.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('roof_materials') && 
							_.isEqual(getFieldValue('roof_materials'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other roof materials'>
									{ getFieldDecorator('roof_materials_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other roof materials'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Construction materials of the outer walls'>
								{ getFieldDecorator('outerwall_materials', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											OUTERWALLS_MATERIALS.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('outerwall_materials') && 
							_.isEqual(getFieldValue('outerwall_materials'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other outer wall materials'>
									{ getFieldDecorator('outerwall_materials_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other outer wall materials'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Finishing materials of the floor of the housing unit'>
								{ getFieldDecorator('floor_finishing_materials', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											FLOOR_FINISHING_MATERIALS.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('floor_finishing_materials') && 
							_.isEqual(getFieldValue('floor_finishing_materials'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other floor finishing materials'>
									{ getFieldDecorator('floor_finishing_materials_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other floor finishing materials'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Construction materials of the floor of the housing unit'>
								{ getFieldDecorator('floor_construction_materials', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											FLOOR_CONSTRUCTION_MATERIALS.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('floor_construction_materials') && 
							_.isEqual(getFieldValue('floor_construction_materials'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other floor construction materials'>
									{ getFieldDecorator('floor_construction_materials_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other floor construction materials'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='State of repair of the housing unit'>
								{ getFieldDecorator('repair_state', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											REPAIR_STATE.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Year was building was built when was this building / housing unit'>
								{ getFieldDecorator('built_year', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											BUILT_YEAR.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Floor area of the housing unit'>
								{ getFieldDecorator('floor_area', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											FLOOR_AREA.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Tenure status of the housing unit'>
								{ getFieldDecorator('tenure_status', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											TENURE_STATUS.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Acquisition of the housing unit?'>
								{ getFieldDecorator('house_acquisition', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											HOUSE_ACQUISITION.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('house_acquisition') && 
							_.isEqual(getFieldValue('house_acquisition'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other housing acquisition'>
									{ getFieldDecorator('house_acquisition_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other housing acquisition'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Monthly rental of the housing unit'>
								{ getFieldDecorator('monthly_rental', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											MONTHLY_RENTAL.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Usual manner of garbage disposal?'>
								{ getFieldDecorator('garbage_disposal', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											GARBAGE_DISPOSAL.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('garbage_disposal') && 
							_.isEqual(getFieldValue('garbage_disposal'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other garbage disposal'>
									{ getFieldDecorator('garbage_disposal_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other garbage disposal'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Kind of toilet facility'>
								{ getFieldDecorator('toilet_facility', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											TOILET_FACILITY.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('toilet_facility') && 
							_.isEqual(getFieldValue('toilet_facility'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other toilet facility'>
									{ getFieldDecorator('toilet_facility_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other toilet facility'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Fuel for lighting'>
								{ getFieldDecorator('lighting_fuel', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											LIGHTING_FUEL.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('lighting_fuel') && 
							_.isEqual(getFieldValue('lighting_fuel'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other lighting fuel'>
									{ getFieldDecorator('lighting_fuel_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other lighting fuel'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Fuel for cooking'>
								{ getFieldDecorator('cooking_fuel', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											COOKING_FUEL.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('cooking_fuel') && 
							_.isEqual(getFieldValue('cooking_fuel'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other cooking fuel'>
									{ getFieldDecorator('cooking_fuel_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other cooking fuel'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Source of water supply for drinking'>
								{ getFieldDecorator('water_supply_drinking', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											WATER_SUPPLY_DRINKING.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('water_supply_drinking') && 
							_.isEqual(getFieldValue('water_supply_drinking'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other source of water for drinking'>
									{ getFieldDecorator('water_supply_drinking_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other source of water for drinking'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={12} sm={24}>
							<Form.Item label='Source of water supply for cooking'>
								{ getFieldDecorator('water_supply_cooking', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											WATER_SUPPLY_COOKING.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('water_supply_cooking') && 
							_.isEqual(getFieldValue('water_supply_cooking'), 'Other specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other source of water for cooking'>
									{ getFieldDecorator('water_supply_cooking_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other source of water for cooking'/>
									)}
								</Form.Item>
							</Col>
						}
					</Row>
					<legend>Land Census</legend>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Land/Lot Location'>
								{ getFieldDecorator('land_location', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											LAND_LOCATION.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Land ownership'>
								{ getFieldDecorator('land_ownership', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											LAND_OWNERSHIP.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('land_ownership') && 
							_.isEqual(getFieldValue('land_ownership'), 'Other land/s specify')) &&
							<Col md={12} sm={24}>
								<Form.Item label='Other land ownership'>
									{ getFieldDecorator('land_ownership_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other land ownership'/>
									)}
								</Form.Item>
							</Col>
						}
						<Col md={24} sm={24}>
							<Form.Item label='Presence of operator in crop farming, livestock and / or poultry raising, 
												aquaculture fishing, and other farm activities'>
								{ getFieldDecorator('presence_operator', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Dropdown' allowClear>
										{
											PRESENCE_OPERATOR.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						{
							(getFieldValue('presence_operator') && 
							_.isEqual(getFieldValue('presence_operator'), 'Other farm activity, specify')) &&
							<Col md={24} sm={24}>
								<Form.Item label='Other farm activities'>
									{ getFieldDecorator('presence_operator_others', {
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Other farm activities'/>
									)}
								</Form.Item>
							</Col>
						}
					</Row>
				</Form>
			</Modal>
		)
	}
}

const SET_HOUSEHOLD = gql`
    mutation setHousehold($input: JSON) {
		setHousehold(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-term' }),
	inject('AuthStore'),
	graphql(SET_HOUSEHOLD, {
		props({ mutate }) {
			return {
				saveHousehold(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allBarangayHousehold']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
